<template>
  <button
    :title="titleTooltip"
    :class="{ 'main-icon': true, 'main-icon--inactive': !this.active, 'main-icon--active': !!this.active}"
    @click="$emit('click',$event)"
  >
    <div class="main-icon__pictogram">
      <img v-if="!getContrastActive || !this.active" class="main-icon__pictogram__lc"
           :src="icon"
           :alt="icon"
      />
      <img v-else class="main-icon__pictogram__hc"
           :src="iconhc"
           :alt="iconhc"
      />
    </div>
    <div :class="{
      'main-icon__text': true,
      'main-icon__text--inactive': !this.active,
    }">
      {{ text }}
    </div>
  </button>
</template>

<script lang="ts">
import { computed, defineComponent, Ref } from 'vue';
import store                              from '@/store';

const Template: object = defineComponent({
  props: {
    active: {
      type: Boolean,
      default: true,
    },
    icon: {
      type: String,
      // eslint-disable-next-line global-require
      default: require('@/assets/img/top_icons/map.svg'),
    },
    iconhc: {
      type: String,
      // eslint-disable-next-line global-require
      default: require('@/assets/img/top_icons/map.svg'),
    },
    text: {
      type: String,
      // eslint-disable-next-line global-require
      default: '<placeholder>',
    },
    titleTooltip: {
      type: String,
      // eslint-disable-next-line global-require
      default: '<placeholder>',
    },
  },
  name: 'MainIcon',
  setup() {
    const getContrastActive: Ref<boolean> = computed((): boolean => store.getters.getContrastActive);

    return {
      getContrastActive,
    };
  },
});
export default Template;
</script>

<style scoped lang="scss">

.main-icon {
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transition: transform ease-in-out 0.3s,
  opacity ease-in-out 0.3s;
  box-sizing: border-box;
  min-width: rem(90px);
  position: relative;
  outline: none !important;

  &:after {
    content: '';
    position: absolute;
    bottom: -10px;
    height: 2px;
    width: 0;
    left: 0;
    background: #fff;
    transition: all 0.3s ease-in;
  }

  &__pictogram {
    img {
      height: rem(50px);
    }
  }

  &__text {
    font-weight: 600;
    font-size: rem(14px);
    line-height: rem(16px);
    letter-spacing: rem(0.7px);
    overflow-wrap: break-spaces;
    text-transform: uppercase;
    max-width: rem(80px);
    text-align: center;
    color: white;
    transition: color ease-in-out 0.3s;

    &--inactive {
      color: #000034;
    }
  }

  &--inactive {
    opacity: 0.3;
    transform: scale(0.9);
  }

  &--active {
    &:after {
      width: 100%;
      transition: all 0.3s ease-in;
    }
  }
}
</style>
